<template>
  <div>
    <div class="title">
      网页title设置：{{ title }}
      <el-button type="primary" size="mini" @click="editSummary(title, 0, 500)"
        >编辑</el-button
      >
    </div>
    <div class="head"><img src="@/assets/image/home/head.png" alt="" /></div>
    <div class="body_wrap">
      <img src="@/assets/image/home/invest/01.png" alt="" />
      <div class="data-body">
        <div class="left">
          <img src="@/assets/image/home/invest/02.png" alt="" />
        </div>
        <div class="right">
          <img src="@/assets/image/home/invest/03.png" alt="" />
          <div class="advert">
            <img
              v-if="advert01.imageUrl"
              :src="$utils.fileUrl(advert01.imageUrl)"
              alt=""
            />
            <span class="tips">图片尺寸：400*256px 格式：jpg、png</span>
            <el-button
              type="primary"
              size="mini"
              @click="editAdver(advert01, 1)"
            >
              更换
            </el-button>
          </div>
          <h2>投融语录</h2>
          <div
            v-for="(item, index) in quotation"
            :key="index"
            class="quotations"
          >
            <li class="name">
              <el-input
                size="mini"
                v-model="item.title"
                maxlength="20"
                show-word-limit
              ></el-input>
              <el-button size="mini" type="danger" @click="del(index)"
                >删除</el-button
              >
            </li>
            <el-input
              resize="none"
              rows="5"
              type="textarea"
              placeholder="请输入内容"
              v-model="item.content"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </div>
          <li>
            <el-button
              size="small"
              type="primary"
              v-if="quotation.length < 5"
              @click="add"
              >添加</el-button
            >
            <el-button size="small" type="primary" @click="save"
              >保存</el-button
            >
          </li>
        </div>
      </div>
    </div>

    <!-- 广告 -->
    <el-dialog
      v-model="advert_dialog"
      title="编辑广告"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="advertForm"
          :rules="advertRules"
          size="mini"
          ref="advertForm"
          label-width="80px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <label
              class="upload-advert"
              for="file"
              :style="
                advertForm.imageUrl
                  ? `background-image: url(${$utils.fileUrl(
                      advertForm.imageUrl
                    )})`
                  : ''
              "
            >
              <i class="el-icon-plus" v-if="!advertForm.imageUrl"></i>
              <input type="file" id="file" @change="upload($event)" />
            </label>
          </el-form-item>
          <el-form-item label="链接：" prop="imageLink">
            <el-input
              placeholder="链接"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageLink"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input
              rows="5"
              resize="none"
              type="textarea"
              placeholder="简介"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageExplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="advert_dialog = false" size="mini">取消</el-button>
          <el-button @click="submit_advert" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      advert01: {},
      quotation: [],
      advert_dialog: false,
      advertForm: {
        imageUrl: "",
        imageExplain: "",
        imageLink: "",
        pageLocation: null,
      },
      advertRules: {
        imageUrl: [
          { required: true, message: "请选择广告图片", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    async getData() {
      try {
        const res = await this.$api.pageManage.getData(8);
        if (res.code === 10200) {
          this.advert01 = res.data.advert01;
          this.quotation = res.data.quotation;
          this.title = res.data.webTitle.content;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    // 编辑概述
    editSummary(content, type, limit = 30) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > limit) return `最多输入${limit}个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          const params = {
            content: value,
            pageType: 8,
            pageLocation: type,
          };
          this.setSummary(params);
        })
        .catch(() => {});
    },
    // 保存概述
    async setSummary(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setSummary(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    upload(e) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile(5, files)
          .then((res) => {
            this.$message.success("上传成功");
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.advertForm.imageUrl = res;
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    editAdver(data, type) {
      this.advertForm.imageUrl = data.imageUrl;
      this.advertForm.imageLink = data.imageLink;
      this.advertForm.imageExplain = data.imageExplain;
      this.advertForm.pageLocation = type;
      this.advert_dialog = true;
    },
    submit_advert() {
      this.$refs["advertForm"].validate((valid) => {
        if (valid) {
          //   this.set_advert();
          this.advert01.imageUrl = this.advertForm.imageUrl;
          this.advert01.imageExplain = this.advertForm.imageExplain;
          this.advert01.imageLink = this.advertForm.imageLink;
          this.advert_dialog = false;
        } else {
          return false;
        }
      });
    },

    del(index) {
      this.quotation.splice(index, 1);
    },
    add() {
      this.quotation.push({
        id: null,
        title: "",
        content: "",
        type: 1,
        // seq: this.quotation.length + 1,
      });
    },
    async save() {
      if (!this.loading) {
        try {
          const quotation = [];
          let count = 0;
          this.quotation.forEach((item, index) => {
            if (item.title && item.content) {
              item.seq = index + 1;
              quotation.push(item);
            } else {
              count++;
            }
          });
          if (count > 0) {
            this.$message.warning("标题和内容都不能为空");
            return;
          }
          this.loading = true;
          this.$loading.start();
          const params = {
            imageUrl: this.advert01.imageUrl,
            imageExplain: this.advert01.imageExplain,
            imageLink: this.advert01.imageLink,
            pageType: 8,
            quotationList: quotation,
          };
          const res = await this.$api.pageManage.setInvestFinancing(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.advert_dialog = false;
            this.getData();
            this.$message.success("保存成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 24px;
  font-size: 0.875rem;
  background-color: #ffffff;

  .el-button {
    margin-left: 40px;
  }
}
.head {
  display: flex;
  margin-bottom: 24px;
  img {
    width: 100%;
  }
}

.body_wrap {
  max-width: 1400px;
  margin: 0 auto;
  img {
    width: 100%;
  }
  .data-body {
    display: flex;
    margin-top: 20px;
    .left {
      flex: 1;
      padding: 0 10px;
      margin-right: 80px;
    }
    .right {
      width: 400px;

      h2 {
        font-weight: 500;
        font-size: 1.125rem;
        margin-bottom: 10px;
      }
      .advert {
        width: 100%;
        font-size: 0;
        min-height: 256px;
        margin-top: 15px;
        margin-bottom: 15px;
        position: relative;
        margin-bottom: 15px;
        border: 1px solid $--color-danger;

        .tips {
          top: 20px;
          left: 20px;
          z-index: 9;
          padding: 3px 10px;
          position: absolute;
          font-size: 0.75rem;
          background-color: $--color-warning;
        }
        img {
          width: 100%;
        }
        input {
          display: none;
        }

        .el-button {
          left: 20px;
          bottom: 20px;
          width: 100px;
          position: absolute;
        }
      }

      .quotations {
        &:not(:last-child) {
          margin-bottom: 20px;
        }
        .name {
          display: flex;
          padding: 10px 0;
          .el-input {
            margin-right: 20px;
          }
        }
      }
    }
  }
}

.upload-advert {
  width: 100px;
  height: 80px;
  cursor: pointer;
  line-height: 80px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid $--border-color-base;
  input {
    display: none;
  }
}
</style>